import { createMuiTheme } from "@material-ui/core/styles"
import color from "./color"

const defaultTheme = createMuiTheme()
const { breakpoints } = defaultTheme
// console.log(breakpoints.values)
// xl: 1920
// lg: 1280
// md: 960
// sm: 600
// xs: 0
const mui = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: "Libre Franklin",
    h1: {
      fontSize: "3rem",
      lineHeight: 1.1,
      fontWeight: 800, // extra bold
      color: color.green,
      marginBottom: "30px",
      [breakpoints.down("sm")]: {
        fontSize: "2rem",
        lineHeight: "2rem"
      }
    },
    h2: {
      fontSize: "1.5rem",
      lineHeight: 1.1,
      fontWeight: 700, // bold
      color: color.green
    },
    h3: {
      fontSize: "1.25rem",
      lineHeight: 1.3,
      fontWeight: "bold",
      color: color.primary
    },
    h4: {
      fontSize: "1.25rem",
      lineHeight: "1.75rem",
      fontWeight: "normal",
      color: color.primary
    },
    h5: {
      fontSize: "1rem",
      lineHeight: "1.625rem",
      fontWeight: 700,
      color: color.primary
    },
    h6: {
      fontSize: "1.125rem",
      lineHeight: "1.75rem",
      fontWeight: 600,
      color: color.darkTan
    },
    subtitle1: {
      // sidebar title
      fontSize: "1rem",
      letterSpacing: "1px",
      fontWeight: 500,
      color: "white"
    },
    subtitle2: {
      // nav bar & table title
      color: "white",
      fontSize: "0.875rem",
      fontWeight: 500,
      letterSpacing: "0.5px"
    },

    body1: { fontSize: "1.1rem" },

    body2: {
      color: color.primary,
      fontSize: "0.875rem",
      lineHeight: "1.5rem",
      letterSpacing: "1px"
    },
    caption: {
      // sidebar item
      color: "black",
      fontSize: "0.875rem",
      letterSpacing: "0.85px",
      fontWeight: 500
    },
    button: {
      fontSize: "1rem",
      letterSpacing: "1px",
      lineHeight: "19px",
      fontWeight: "bold",
      color: color.primary
    }
  },
  palette: {
    primary: {
      main: color.primary,
      contrastText: "white"
    },
    secondary: {
      main: color.secondary
    }
  },
  // https://material-ui.com/customization/themes/
  overrides: {
    MuiTypography: {
      gutterBottom: {
        marginBottom: "0.35rem",
        [breakpoints.down("sm")]: {
          marginBottom: "0.25rem"
        }
      }
    }
  }
})

export default mui

// ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1",
// "subtitle2", "body1", "body2", "caption", "button",
// "overline", "srOnly", "inherit",

// deprecated
// "title"
// "subheading"
// "display4", "display3",
// "display2", "display1", "headline",
